import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { FacturaEstadoGateway } from "src/app/domain/models/factura-estado/gateways/factura-estado.gateway";
import { FacturaEstadoModel } from "src/app/domain/models/factura-estado/factura-estado.model";
import { environments } from "src/environments/environment";
import { RolesModel } from "src/app/domain/models/factura-estado/roles.model";


@Injectable({
    providedIn: 'root'
})
export class FacturaEstadoAdapter extends FacturaEstadoGateway {
    
    _back_url_base: string;

    constructor(private http: HttpClient) {
        super();
        this._back_url_base = environments.BACK_URL_BASE;
    }

    findAll(): Observable<[FacturaEstadoModel]> {
        const url = `${this._back_url_base}api/factura/estados`;
        return this.http.get<[FacturaEstadoModel]>(
            url
        );
    }

    getRoles(username: string): Observable<[RolesModel]> {
        const url = `${this._back_url_base}api/usuario/rol/${username}`;
        return this.http.get<[RolesModel]>(
            url
        );
    }

    
}